import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import { API_URL } from "../components/Constant";
import Header from "../components/Header";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Colors from "../components/Colors";

const Theme = () => {
  const [allTheme, setAllTheme] = useState([]);
  const [newThemeName, setNewThemeName] = useState("");
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await axios.get(`${API_URL}/all_theme`);
        setAllTheme(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameData();
    const intervalId = setInterval(fetchGameData, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const handleThemeClick = (theme) => {
    localStorage.setItem("theme", theme);
    if (localStorage.getItem("gameId")) {
      window.location.href = "/crossword-creator";
    } else {
      window.location.href = "/game_name";
    }
  };

  const handleCustomThemeClick = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAddNewTheme = async () => {
    if (newThemeName) {
      try {
        const response = await axios.post(`${API_URL}/add_theme`, {
          theme: newThemeName,
        });
        if (response.data.success === true) {
          localStorage.setItem("theme", newThemeName);
          window.location.href = "/game_name";
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setOpenModal(false);
      setNewThemeName("");
    }
  };

  // Add custom theme to the end of the list
  const themesWithCustom = [...allTheme, { theme: "Create Your Own Theme" }];

  // Chunking themes into rows of up to 5 items
  const chunkedThemes = [];
  for (let i = 0; i < themesWithCustom.length; i += 5) {
    chunkedThemes.push(themesWithCustom.slice(i, i + 5));
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: Colors.bgColor,
      }}
    >
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "16px",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {chunkedThemes.map((themeRow, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              maxWidth: "80%",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
            }}
          >
            {themeRow.map((theme, i) => (
              <Box
                key={i}
                onClick={() =>
                  theme.theme === "Create Your Own Theme"
                    ? handleCustomThemeClick()
                    : handleThemeClick(theme.theme)
                }
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  padding: "8px",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "200px",
                  height: "60px",
                  background: "#f0f0f0",
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    color: Colors.Tidesfont,
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {theme.theme}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}

        {openModal && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "5",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                gap: "5px",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  width: { md: "25%", sm: "25%", xs: "85%" },
                  height: "36px",
                  justifyContent: "right",
                  alignItems: "right",
                  display: "flex",
                }}
              >
                <IconButton
                  onClick={handleCloseModal}
                  sx={{
                    position: "fixed",
                    width: "36px",
                    height: "36px",
                  }}
                >
                  <CloseOutlinedIcon
                    sx={{
                      width: "36px",
                      height: "36px",
                      color: "#F9F9F9",
                      "&:hover": {
                        width: "40px",
                        height: "40px",
                        color: "#F9F9F9",
                        backgroundColor: "none",
                        background: "none",
                      },
                    }}
                  ></CloseOutlinedIcon>
                </IconButton>
              </Box>
              <Box
                sx={{
                  width: { md: "25%", sm: "25%", xs: "85%" },
                  height: "fit-content",
                  backgroundColor: "#FFF",
                  border: "1px solid",
                  borderColor: "#FFF",
                  borderRadius: "4px ",
                  boxShadow: "none",
                  boxSizing: "border-box",
                  zIndex: "3",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: "16px",
                      paddingTop: "13%",
                      justifyContent: "center",
                      alignContent: "center",
                      height: "86%",
                      maxWidth: "85%",
                      paddingBottom: "13%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: "20px",
                        justifyContent: "center",
                        alignContent: "center",
                        height: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "18px",
                          color: Colors.Tidesfont,
                          fontWeight: 600,
                        }}
                      >
                        Add New Theme
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          height: "fit-content",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          gap: "8px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Roboto",
                            fontSize: { xs: "12px", md: "14px" },
                            fontWeight: 400,
                          }}
                        >
                          Enter your new theme:
                        </Typography>
                        <TextField
                          value={newThemeName}
                          onChange={(e) => setNewThemeName(e.target.value)}
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            sx: {
                              height: { md: "32px", xs: "28px" },
                              padding: "4px 10px",
                              fontSize: { md: "14px", xs: "12px" },
                            },
                          }}
                          sx={{ borderRadius: "8px" }}
                        />
                      </Box>

                      <Box
                        sx={{
                          width: "100%",
                          flexDirection: "row",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                          gap: { xs: "8px", md: "16px" },
                          marginTop: "16px",
                        }}
                      >
                        <Button
                          onClick={handleCloseModal}
                          sx={{
                            background: Colors.button1,
                            color: "#fff",
                            width: "50%",
                            border: "1px solid",
                            borderColor: Colors.button1,
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "12px",
                            transition: "background 0.3s, transform 0.3s",
                            "&:hover": {
                              background: Colors.button1,
                              transform: "scale(1.05)",
                            },
                            "&:active": {
                              background: Colors.button1,
                            },
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={handleAddNewTheme}
                          sx={{
                            background: Colors.button2,
                            color: "#fff",
                            width: "50%",
                            border: "1px solid",
                            borderColor: Colors.button2,
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "12px",
                            transition: "background 0.3s, transform 0.3s",
                            "&:hover": {
                              background: Colors.button2,
                              transform: "scale(1.05)",
                            },
                            "&:active": {
                              background: Colors.button2,
                            },
                          }}
                        >
                          Add Theme
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Theme;
